import { FC } from "react";
import Modal from "@Components/Modal";
import styles from "./mapModalStyles.module.scss";
import Portal from "@Components/Portal";

export const MapModal: FC<any> = ({ onClose, title, children }) => (
  <Portal>
    <Modal title={title} className={styles.mapModalContainer} hideModal={onClose} zIndex={400}>
      {children}
    </Modal>
  </Portal>
);

export default MapModal;
